const AdditionalParameterModalIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      id='svg3'
      width='56'
      height='56'
      fill='none'
      version='1.1'
      viewBox='0 0 56 56'
    >
      <rect id='rect1' width='48' height='48' x='4' y='4' fill='#ECE9F2' rx='24'></rect>
      <rect
        id='rect2'
        width='48'
        height='48'
        x='4'
        y='4'
        stroke='#E2DEEC'
        strokeWidth='8'
        rx='24'
      ></rect>
      <g id='g2' clipPath='url(#clip0_19970_143625)'>
        <path
          id='path2'
          fill='#402080'
          d='M28 25.5h3.333a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.834H28a.836.836 0 0 0-.833.834c0 .458.375.833.833.833m0 3.333h3.333a.836.836 0 0 0 .834-.833.836.836 0 0 0-.834-.833H28a.836.836 0 0 0-.833.833c0 .458.375.833.833.833m0 3.334h3.333a.836.836 0 0 0 .834-.834.836.836 0 0 0-.834-.833H28a.836.836 0 0 0-.833.833c0 .459.375.834.833.834m-4.167-8.334H25.5V25.5h-1.667zm0 3.334H25.5v1.666h-1.667zm0 3.333H25.5v1.667h-1.667zm10.834-10H21.333a.836.836 0 0 0-.833.833v13.334c0 .458.375.833.833.833h13.334a.836.836 0 0 0 .833-.833V21.333a.836.836 0 0 0-.833-.833m-.834 13.333H22.167V22.167h11.666z'
        ></path>
      </g>
      <defs id='defs3'>
        <clipPath id='clip0_19970_143625'>
          <path id='rect3' fill='#fff' d='M0 0h20v20H0z' transform='translate(18 18)'></path>
        </clipPath>
      </defs>
    </svg>
  )
}
export default AdditionalParameterModalIcon
